import MeetingSummaryCancelation from './MeetingSummaryCancelation';

export default MeetingSummaryCancelation;
